/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef } from 'react';
import * as Sentry from '@sentry/react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router';
import qs from 'query-string';
import AutoCompleteTaggedField from '../../common/AutoCompleteTaggedField';
import DropdownFormInput from '../../common/DropdownFormInput';
import DatePicker from '../../common/DatePicker';
import DropDown from '../../common/DropDown';
import { REPORT_TYPES, DROPDOWN_VARIANTS } from '../../common/constants';
import CustomSlider from '../../common/Slider';
import CheckBox from '../../common/CheckBox';
import PropTypes from 'prop-types';
// import ConnectedTable from './ConnectedCSVTable';
import buildingIcon from '../../icons/building.svg';
import './styles.scss';
import { CSVLink } from 'react-csv';
// import { transformMapData } from '../../map/transformers/';
import ReportDemo from './Report';
import ReportMap from './ReportMap';
// import DownloadCsv from './DownloadCsv';
import DownloadReport from './DownloadReport';
import { TAG_TYPE, startOfMonth } from './constants';
import { arrayOfObjectsToIdsStr } from '../../common/utils';
import downloadAsImage from '../../helpers/downloadAsImage';
import InfoIcon from '../../icons/info.svg';
import moment from 'moment';
import { ROUTE_DOWNLOAD_CHALLENGES } from '../../navigation/constants';
import {
    challengesRequested,
    tagsRequested,
    usersRequested,
    countriesAndCitiesRequested,
    // generatePreviewReportRequested,
    generateCSVReportRequested,
    setSelectedCountries,
} from './actions';
import {
    getChallenges,
    getTags,
    getUsers,
    getCountries,
    getPreviewReport,
    // getPreviewReportLoading,
    getCSVReportLoading,
    // getCSVReport,
    getCSVReportCOMBO,
    getTotalCount,
    getCities,
} from './selectors';

import { getCsv, getMs4Report } from '../../api';

import FormInput from '../../common/FormInput';
import LoadingComponent from '../../common/LoadingComponent';
import { TextField } from '@material-ui/core';
import { getUser, getUserPermissionsKeys } from '../auth/selectors';

function DownloadChallenges({
    fetchChallenges,
    fetchCountries,
    setSelectedCountriesIds,
    fetchTags,
    fetchUsers,
    generateReport,
    challenges,
    tags,
    users,
    user,
    loadingPreview,
    countries,
    cities,
    report,
    totalCount,
    permissions,
}) {
    const history = useHistory();
    const location = useLocation();
    const queryParams = qs.parse(location.search);
    // scroll top top
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const { rolePermissions } = user;
    const { roleId } = rolePermissions;
    const cannotSwitchUser = roleId && roleId >= 100 && roleId < 200;
    const canSearchWithCommas = roleId && roleId >= 300 && roleId < 500;
    const csvLink = React.createRef();
    const [usersAllSelected, setUsersAllSelected] = useState(false);
    const [challengesAllSelected, setChallengesAllSelected] = useState(false);
    const [tagsAllSelected, setTagsAllSelected] = useState(false);
    // state of challenges selected by the user and function to pass to autocomplete
    // to update the state on selection
    const [selectedChallenges, setSelectedChallenges] = useState([]);
    // state of csv download button error message provides message from API
    const [csvError, setCSVerror] = useState(null);
    // default message of csv download button while loading
    const [csvMessage, setCSVMessage] = useState(null);
    const DEFAULT_CSV_LOADING_MESSAGE =
        'Large requests may take between 5-20 minutes depending on network speeds, please do not touch this tab until it finishes';
    const DEFAULT_CSV_ERROR_MESSAGE =
        'Try reducing the data size and report parameters. The CSV cannot be downloaded with this amount of data.';

    // state of tags selected by the user and function to pass to autocomplete
    // to update the state on selection
    const [tagSource, setTagSource] = useState(TAG_TYPE[0].label);
    const [selectedTags, setSelectedTags] = useState([]);

    // state of users selected by the user and function to pass to autocomplete
    // to update the state on selection
    const [selectedUsers, setSelectedUsers] = useState([]);

    // state of startDate selected by the user and function to pass to datepicker
    // to update the state on selection
    const [selectedStartDate, setSelectedStartDate] = useState(
        startOfMonth(new Date()),
    );

    // state of endDate selected by the user and function to pass to datepicker
    // to update the state on selection
    const [selectedEndDate, setSelectedEndDate] = useState(new Date());

    // state of radius selected by the user and function to pass to slider
    // to update the state on selection
    const [selectedRadius, setSelectedRadius] = useState(0);

    // state of zipcode entered by the user and function to
    // update the state on input
    const [selectedZipcode, setSelectedZipcode] = useState(null);

    const [selectedCountries, setSelectedCountries] = useState([]);
    const [selectedCities, setSelectedCities] = useState(null);

    const [searchClicked, setSearchClicked] = useState(false);
    const [mapFilters, setMapFilters] = useState({});
    // const [mapUpdatedData, setMapUpdatedData] = useState([...mapData]);

    const [isDownloading, setDownloading] = useState(false);
    const [isDownloadingCSV, setDownloadingCSV] = useState(false);
    const [csvData, setCSVData] = useState('');
    const [reportType, setReportType] = useState(REPORT_TYPES[0].key);
    const [isDownloadingMs4, setIsDownloadingMs4] = useState(null);
    const [ms4Error, setMs4Error] = useState(null);

    useEffect(() => {
        if (csvData) {
            csvLink.current.link.target = '_blank';
            csvLink.current.link.click();
            setCSVData('');
        }
    }, [csvData]);

    const reportDemo = useRef();

    function setFilledState(id, isSelected, setSelectedState) {
        // if checkbox was false and is being set to true then clear selection
        // and unselect all tag pills
        if (!isSelected) {
            clearSelection(id, setSelectedState);
        }
    }

    function clearSelection(id, cb) {
        clearAutocompleteState(id);
        cb([]);
    }

    function clearAutocompleteState(id) {
        try {
            document
                .getElementById(id) // call clear event of AutoComplete field
                .parentNode.getElementsByClassName(
                    'MuiAutocomplete-clearIndicator',
                )[0]
                .click();
        } catch (e) {
            Sentry.captureException(e);
            console.log(e);
        }
    }

    // useEffect(() => {
    //     if (
    //         queryParams &&
    //         Object.keys(queryParams).length > 0 &&
    //         challenges &&
    //         tags &&
    //         countries &&
    //         users
    //     ) {
    //         if (queryParams.selectedEndDate !== 'null') {
    //             setSelectedEndDate(new Date(queryParams.selectedEndDate));
    //         } else {
    //             setSelectedEndDate(null);
    //         }
    //         if (queryParams.selectedStartDate !== 'null') {
    //             setSelectedStartDate(new Date(queryParams.selectedStartDate));
    //         } else {
    //             setSelectedStartDate(null);
    //         }
    //         const TAGSOURCE = queryParams.tagSource
    //             ? (
    //                   TAG_TYPE.find(
    //                       (item) => item.key === queryParams.tagSource,
    //                   ) || {}
    //               ).label
    //             : TAG_TYPE[0].label;

    //         if (queryParams.tagSource) setTagSource(TAGSOURCE);
    //         if (queryParams.selectedZipcode)
    //             setSelectedZipcode(queryParams.selectedZipcode);
    //         if (queryParams.selectedRadius)
    //             setSelectedRadius(parseInt(queryParams.selectedRadius));
    //         if (queryParams.selectedChallenges)
    //             setSelectedChallenges(
    //                 JSON.parse(queryParams.selectedChallenges || '[]'),
    //             );
    //         if (queryParams.selectedUsers)
    //             setSelectedUsers(JSON.parse(queryParams.selectedUsers || '[]'));
    //         if (queryParams.selectedTags)
    //             setSelectedTags(JSON.parse(queryParams.selectedTags || '[]'));
    //         if (queryParams.selectedCountries)
    //             setSelectedCountries(
    //                 JSON.parse(queryParams.selectedCountries || '[]'),
    //             );
    //         if (queryParams.selectedCities)
    //             setSelectedCities(
    //                 JSON.parse(queryParams.selectedCities || '[]'),
    //             );

    //         setSearchClicked(true);
    //         setCSVerror(null);
    //         setCSVMessage(null);
    //         generateReport({
    //             selectedChallenges,
    //             selectedUsers: cannotSwitchUser
    //                 ? [{ id: user.id }]
    //                 : selectedUsers,
    //             selectedTags,
    //             tagSource,
    //             selectedStartDate,
    //             selectedEndDate,
    //             selectedZipcode,
    //             selectedRadius,
    //             selectedCountries,
    //             selectedCities,
    //         });
    //     }
    // }, [challenges, tags, countries, users]);

    function clearFilters() {
        setSearchClicked(false);
        setCSVerror(null);
        setCSVMessage(null);
        setSelectedChallenges([]);
        setSelectedUsers([]);
        setSelectedTags([]);
        setTagSource(TAG_TYPE[0].label);
        setSelectedStartDate(startOfMonth(new Date()));
        setSelectedEndDate(new Date());
        setSelectedRadius(0);
        setSelectedZipcode(null);
        setSelectedCountries(null);
        clearSelection('channels-autocomplete', setSelectedChallenges);
        clearSelection('users-autocomplete', setSelectedUsers);
        clearSelection('tags-autocomplete', setSelectedUsers);

        clearSelection('cities-autocomplete', setSelectedCities);
        clearSelection('countries-autocomplete', setSelectedCountries);
    }

    const loader = (
        <div className="buttonLoader">
            <LoadingComponent isLoading={loadingPreview || isDownloadingMs4} />
        </div>
    );

    const buttonText =
        loadingPreview || isDownloadingMs4 ? loader : 'Generate Report'; // 'Generate Report'

    useEffect(() => {
        fetchChallenges();
        fetchCountries();
        fetchTags();
        fetchUsers();
    }, []);

    return (
        <div className="download-report">
            <div
                className="d-flex"
                style={{
                    justifyContent: 'space-between',
                    alignItems: 'baseline',
                }}
            >
                <h1>
                    Create Your{' '}
                    {reportType === REPORT_TYPES[0].key
                        ? 'Custom Data Reports'
                        : REPORT_TYPES[1].label}
                </h1>
                {permissions.includes('pp_ms4_report_download') && (
                    <div style={{ width: 210, marginTop: 40, marginRight: 8 }}>
                        <DropDown
                            label={''}
                            menuData={REPORT_TYPES}
                            onChange={(val) => {
                                setReportType(val);
                                if (val === REPORT_TYPES[0].key) {
                                    setSelectedStartDate(
                                        startOfMonth(new Date()),
                                    );
                                    setSelectedEndDate(new Date());
                                } else {
                                    setSelectedStartDate(null);
                                    setSelectedEndDate(null);
                                }
                            }}
                            variant={DROPDOWN_VARIANTS.LIST_SIMPLE}
                        />
                    </div>
                )}
            </div>
            <div className="col-md-12">
                <div className="content-box card">
                    <div className="row">
                        <div className="filterForm">
                            <div className="col pl-2">
                                <h2 className="mb-24">Filter</h2>
                            </div>
                            {reportType === REPORT_TYPES[0].key && (
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="clearWraper">
                                            <CheckBox
                                                id={'all-channels'}
                                                selected={challengesAllSelected}
                                                onClick={() => {
                                                    setFilledState(
                                                        'channels-autocomplete',
                                                        challengesAllSelected,
                                                        setSelectedChallenges,
                                                    );
                                                    setChallengesAllSelected(
                                                        !challengesAllSelected,
                                                    );
                                                }}
                                                className="checkCard"
                                                label={'All'}
                                            />
                                            <a
                                                className="clear"
                                                onClick={() =>
                                                    clearSelection(
                                                        'channels-autocomplete',
                                                        setSelectedChallenges,
                                                    )
                                                }
                                            >
                                                Clear
                                            </a>
                                        </div>
                                        <AutoCompleteTaggedField
                                            id="channels-autocomplete"
                                            title="Challenges"
                                            defaultValue={selectedChallenges}
                                            options={challenges}
                                            onSelect={(challenges) => {
                                                setSelectedChallenges(
                                                    challenges,
                                                );
                                                if (challengesAllSelected) {
                                                    setChallengesAllSelected(
                                                        false,
                                                    );
                                                }
                                            }}
                                            placeholder={`${
                                                selectedChallenges &&
                                                selectedChallenges.length
                                                    ? ''
                                                    : 'Select Challenge'
                                            }`}
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <div className="clearWraper">
                                            <CheckBox
                                                id={'all-users'}
                                                className="checkCard"
                                                label={'All'}
                                                disabled={cannotSwitchUser}
                                                selected={usersAllSelected}
                                                onClick={() => {
                                                    setFilledState(
                                                        'users-autocomplete',
                                                        usersAllSelected,
                                                        setSelectedUsers,
                                                    );
                                                    setUsersAllSelected(
                                                        !usersAllSelected,
                                                    );
                                                }}
                                            />
                                            <a
                                                className="clear"
                                                disabled={cannotSwitchUser}
                                                onClick={() =>
                                                    clearSelection(
                                                        'users-autocomplete',
                                                        setSelectedUsers,
                                                    )
                                                }
                                            >
                                                Clear
                                            </a>
                                        </div>
                                        <AutoCompleteTaggedField
                                            title="Users"
                                            id="users-autocomplete"
                                            bootstrapIcon="icon-latest-multiple-user"
                                            options={users}
                                            allowCommaSeparated={
                                                canSearchWithCommas
                                            }
                                            disabled={cannotSwitchUser}
                                            defaultValue={selectedUsers}
                                            onSelect={(users) => {
                                                setSelectedUsers(users);
                                                if (usersAllSelected) {
                                                    setUsersAllSelected(false);
                                                }
                                            }}
                                            placeholder={`${
                                                selectedUsers &&
                                                selectedUsers.length
                                                    ? ''
                                                    : 'Select user by name, ID or email address'
                                            }`}
                                        />
                                    </div>
                                </div>
                            )}
                            <div className="row">
                                <div className="col-6">
                                    <DatePicker
                                        isTypedKeyboard
                                        title="Start Date"
                                        bootstrapIcon="icon-calendar-empty"
                                        handleDateChange={setSelectedStartDate}
                                        pickerProps={{
                                            clearable: true,
                                            value: selectedStartDate,
                                        }}
                                    />
                                </div>
                                <div className="col-6">
                                    <DatePicker
                                        isTypedKeyboard
                                        title="End Date"
                                        bootstrapIcon="icon-calendar-empty"
                                        handleDateChange={setSelectedEndDate}
                                        pickerProps={{
                                            clearable: true,
                                            value: selectedEndDate,
                                        }}
                                    />
                                </div>
                            </div>
                            {reportType === REPORT_TYPES[0].key ? (
                                <>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="clearWraper">
                                                <CheckBox
                                                    id={'all-tags'}
                                                    selected={tagsAllSelected}
                                                    onClick={() => {
                                                        setFilledState(
                                                            'tags-autocomplete',
                                                            tagsAllSelected,
                                                            setSelectedTags,
                                                        );
                                                        setTagsAllSelected(
                                                            !tagsAllSelected,
                                                        );
                                                    }}
                                                    className="checkCard"
                                                    label={'All'}
                                                />
                                                <a
                                                    className="clear"
                                                    onClick={() =>
                                                        clearSelection(
                                                            'tags-autocomplete',
                                                            setSelectedTags,
                                                        )
                                                    }
                                                >
                                                    Clear
                                                </a>
                                            </div>
                                            <AutoCompleteTaggedField
                                                title="Tags"
                                                id="tags-autocomplete"
                                                bootstrapIcon="icon-tags"
                                                allowCommaSeparated
                                                options={tags}
                                                defaultValue={selectedTags}
                                                onSelect={(tags) => {
                                                    setSelectedTags(tags);
                                                    if (tagsAllSelected) {
                                                        setTagsAllSelected(
                                                            false,
                                                        );
                                                    }
                                                }}
                                                placeholder={
                                                    'Add Tags (ex: food)'
                                                }
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <DropdownFormInput
                                                title="Tag Source"
                                                bootstrapIcon="icon-tags"
                                                menuData={TAG_TYPE}
                                                selected={tagSource}
                                                onSelect={(tagsource) => {
                                                    setTagSource(tagsource);
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <AutoCompleteTaggedField
                                                title="Country"
                                                options={countries}
                                                loading={!countries.length}
                                                id="countries-autocomplete"
                                                bootstrapIcon="icon-world"
                                                defaultValue={selectedCountries}
                                                placeholder={`${
                                                    selectedCountries &&
                                                    selectedCountries.length
                                                        ? ''
                                                        : 'Select country'
                                                }`}
                                                onSelect={(
                                                    countriesSelected,
                                                ) => {
                                                    setSelectedCountries(
                                                        countriesSelected,
                                                    );
                                                    setSelectedCountriesIds(
                                                        countriesSelected.map(
                                                            (c) => c.id,
                                                        ),
                                                    );
                                                    clearSelection(
                                                        'cities-autocomplete',
                                                        setSelectedCities,
                                                    );
                                                }}
                                            />
                                        </div>
                                        <div className="col-6">
                                            <AutoCompleteTaggedField
                                                title="City"
                                                options={cities}
                                                disabled={
                                                    !selectedCountries.length
                                                }
                                                loading={!countries.length}
                                                id="cities-autocomplete"
                                                defaultValue={selectedCities}
                                                bootstrapIcon={buildingIcon}
                                                stylesIcon={{
                                                    justifyContent: 'center',
                                                }}
                                                placeholder={`${
                                                    selectedCities &&
                                                    selectedCities.length
                                                        ? ''
                                                        : 'Add city'
                                                }`}
                                                onSelect={(citiesSelected) => {
                                                    setSelectedCities(
                                                        citiesSelected,
                                                    );
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-6">
                                            <FormInput
                                                title="Zipcode"
                                                bootstrapIcon="icon-location-filled"
                                            >
                                                <TextField
                                                    placeholder={
                                                        'Enter zipcode'
                                                    }
                                                    value={selectedZipcode}
                                                    onChange={(event) =>
                                                        setSelectedZipcode(
                                                            event.target.value,
                                                        )
                                                    }
                                                />
                                            </FormInput>
                                        </div>
                                        <div className="col-6">
                                            <div className="rangeSlider">
                                                <h3 className="titleStyle2">
                                                    Radius
                                                </h3>
                                                <CustomSlider
                                                    value={selectedRadius}
                                                    handleChange={
                                                        setSelectedRadius
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col pl-2">
                                        <button
                                            type="button"
                                            className="btn btn-custom"
                                            disabled={
                                                loadingPreview ||
                                                isDownloadingCSV ||
                                                isDownloading
                                            }
                                            onClick={() => {
                                                // TODO NOTE: this should be true but reset functionality is not working correctly thats why not enabling reset button
                                                // history.push(
                                                //     ROUTE_DOWNLOAD_CHALLENGES +
                                                //         '?' +
                                                //         new URLSearchParams({
                                                //             selectedChallenges: JSON.stringify(
                                                //                 selectedChallenges,
                                                //             ),
                                                //             selectedUsers: JSON.stringify(
                                                //                 selectedUsers,
                                                //             ),
                                                //             selectedTags: JSON.stringify(
                                                //                 selectedTags,
                                                //             ),
                                                //             tagSource,
                                                //             selectedStartDate,
                                                //             selectedEndDate,
                                                //             selectedZipcode:
                                                //                 selectedZipcode ||
                                                //                 '',
                                                //             selectedRadius,
                                                //             selectedCountries: JSON.stringify(
                                                //                 selectedCountries,
                                                //             ),
                                                //             selectedCities: JSON.stringify(
                                                //                 selectedCities,
                                                //             ),
                                                //         }).toString(),
                                                // );
                                                setSearchClicked(true);
                                                setCSVerror(null);
                                                setCSVMessage(null);
                                                generateReport({
                                                    selectedChallenges,
                                                    selectedUsers: cannotSwitchUser
                                                        ? [{ id: user.id }]
                                                        : selectedUsers,
                                                    selectedTags,
                                                    tagSource,
                                                    selectedStartDate,
                                                    selectedEndDate,
                                                    selectedZipcode,
                                                    selectedRadius,
                                                    selectedCountries,
                                                    selectedCities,
                                                });
                                            }}
                                        >
                                            {buttonText}
                                        </button>
                                        {searchClicked ? (
                                            <button
                                                type="button"
                                                className="btn btn-custom reset-btn"
                                                onClick={() => clearFilters()}
                                                disabled={
                                                    loadingPreview ||
                                                    isDownloadingCSV ||
                                                    isDownloading
                                                }
                                            >
                                                Reset
                                            </button>
                                        ) : null}
                                    </div>
                                </>
                            ) : (
                                <div className="row">
                                    <div className="col pl-2">
                                        <button
                                            type="button"
                                            className="btn btn-custom"
                                            style={{ marginLeft: 5 }}
                                            disabled={
                                                loadingPreview ||
                                                isDownloadingCSV ||
                                                isDownloading ||
                                                isDownloadingMs4
                                            }
                                            onClick={() => {
                                                setIsDownloadingMs4(true);
                                                setMs4Error(null);
                                                let startDate = selectedStartDate
                                                    ? moment(
                                                          selectedStartDate.toISOString(),
                                                      )
                                                    : moment();
                                                let endDate = selectedEndDate
                                                    ? moment(
                                                          selectedEndDate.toISOString(),
                                                      )
                                                    : moment();
                                                if (!selectedStartDate) {
                                                    startDate = startDate.subtract(
                                                        1,
                                                        'year',
                                                    );
                                                }
                                                getMs4Report({
                                                    startDate: startDate.format(
                                                        'MM/DD/yyyy',
                                                    ),
                                                    endDate: endDate.format(
                                                        'MM/DD/yyyy',
                                                    ),
                                                })
                                                    .then((response) => {
                                                        const url = window.URL.createObjectURL(
                                                            new Blob([
                                                                response.data,
                                                            ]),
                                                        );
                                                        const link = document.createElement(
                                                            'a',
                                                        );
                                                        link.href = url;
                                                        link.setAttribute(
                                                            'download',
                                                            'LitteratiEngageReport.xlsx',
                                                        );
                                                        document.body.appendChild(
                                                            link,
                                                        );
                                                        link.click();
                                                        link.remove();
                                                        setIsDownloadingMs4(
                                                            null,
                                                        );
                                                    })
                                                    .catch((e) => {
                                                        Sentry.captureException(
                                                            e,
                                                        );
                                                        setIsDownloadingMs4(
                                                            null,
                                                        );
                                                        setMs4Error(
                                                            'There was an error downloading report please try again',
                                                        );
                                                    });
                                            }}
                                        >
                                            {buttonText}
                                        </button>
                                        {ms4Error && (
                                            <span
                                                style={{
                                                    marginLeft: 10,
                                                    color: 'red',
                                                    fontSize: '16px',
                                                }}
                                            >
                                                {ms4Error}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {reportType === REPORT_TYPES[0].key ? (
                <>
                    <div className="spacer"></div>
                    <div className="report-buttons">
                        <DownloadReport
                            loading={isDownloading}
                            disabled={
                                loadingPreview ||
                                isDownloadingCSV ||
                                isDownloading
                            }
                            onDownloadClick={(filetype) => {
                                if (reportDemo) {
                                    setDownloading(true);
                                    setCSVerror(null);
                                    setCSVMessage(null);
                                    downloadAsImage(
                                        reportDemo.current,
                                        'ReportDetails',
                                        filetype,
                                        () => setDownloading(false),
                                    );
                                }
                            }}
                        />
                        <DownloadReport
                            buttonText={'Download CSV'}
                            loading={isDownloadingCSV}
                            disabled={
                                loadingPreview ||
                                isDownloadingCSV ||
                                isDownloading
                            }
                            onDownloadClick={() => {
                                if (reportDemo) {
                                    setDownloadingCSV(true);
                                    setCSVerror(null);
                                    setCSVMessage(DEFAULT_CSV_LOADING_MESSAGE);
                                    getCsv({
                                        challengeIds: arrayOfObjectsToIdsStr(
                                            selectedChallenges,
                                        ),
                                        userIds: cannotSwitchUser
                                            ? user.id
                                            : arrayOfObjectsToIdsStr(
                                                  selectedUsers,
                                              ),
                                        tagIds: arrayOfObjectsToIdsStr(
                                            selectedTags,
                                        ),
                                        tags: (selectedTags || [])
                                            .map((tag) => tag.title)
                                            .join(','),
                                        startDate:
                                            selectedStartDate instanceof Date
                                                ? selectedStartDate
                                                : selectedStartDate
                                                ? new Date(
                                                      selectedStartDate.toString(),
                                                  )
                                                : '',
                                        endDate:
                                            selectedEndDate instanceof Date
                                                ? selectedEndDate
                                                : selectedEndDate
                                                ? new Date(
                                                      selectedEndDate.toString(),
                                                  )
                                                : '',
                                        selectedZipcode,
                                        radius: selectedRadius,
                                        countryCodes: arrayOfObjectsToIdsStr(
                                            selectedCountries,
                                        ),
                                        city: arrayOfObjectsToIdsStr(
                                            selectedCities,
                                        ),
                                    })
                                        .then(({ data }) => {
                                            setCSVData(data);
                                            setDownloadingCSV(false);
                                            setCSVMessage(null);
                                        })
                                        .catch((e) => {
                                            Sentry.captureException(e);
                                            setDownloadingCSV(false);
                                            setCSVMessage(null);
                                            setCSVerror(
                                                e.response.data.message ||
                                                    e.message,
                                            );
                                        });
                                }
                            }}
                        />
                        <CSVLink
                            data={csvData}
                            filename="CSV Report.csv"
                            target="_blank"
                            ref={csvLink}
                        />
                    </div>
                    {csvError && (
                        <div className="report-buttons">
                            <span
                                style={{
                                    fontSize: 13,
                                    fontFamily: 'Proxima Nova Rg',
                                }}
                            >
                                <img
                                    className="info-btn"
                                    src={InfoIcon}
                                    style={{
                                        width: 18,
                                        height: 18,
                                        marginRight: 2,
                                    }}
                                />
                                {csvError || DEFAULT_CSV_ERROR_MESSAGE}
                            </span>
                        </div>
                    )}
                    {csvMessage && (
                        <div className="report-buttons">
                            <span
                                style={{
                                    fontSize: 13,
                                    fontFamily: 'Proxima Nova Rg',
                                }}
                            >
                                <img
                                    className="info-btn"
                                    src={InfoIcon}
                                    style={{
                                        width: 18,
                                        height: 18,
                                        marginRight: 2,
                                    }}
                                />
                                {csvMessage || DEFAULT_CSV_LOADING_MESSAGE}
                            </span>
                        </div>
                    )}
                    <div className="spacer"></div>
                    {!loadingPreview &&
                    searchClicked &&
                    parseInt(totalCount) === 0 ? (
                        <div className="col-md-12">
                            <div className="content-box card no-data-found">
                                <span>No Data Found</span>
                            </div>
                        </div>
                    ) : (
                        ''
                    )}

                    <ReportDemo
                        data={report}
                        totalCount={totalCount}
                        ref={reportDemo}
                        setMapFilters={setMapFilters}
                    />
                    <div className="spacer"></div>
                    {totalCount > 0 && (
                        <ReportMap
                            mapFilters={mapFilters}
                            filters={{
                                selectedChallenges,
                                selectedUsers: cannotSwitchUser
                                    ? [{ id: user.id }]
                                    : selectedUsers,
                                selectedTags,
                                tagSource,
                                selectedStartDate,
                                selectedEndDate,
                                selectedZipcode,
                                selectedRadius,
                                selectedCountries,
                                selectedCities,
                            }}
                        />
                    )}
                </>
            ) : (
                ''
            )}
        </div>
    );
}

DownloadChallenges.propTypes = {
    // function to populate Challenges autocomplete
    fetchChallenges: PropTypes.func.isRequired,
    fetchCountries: PropTypes.func.isRequired,
    setSelectedCountriesIds: PropTypes.func.isRequired,
    // function to populate Tags autocomplete
    fetchTags: PropTypes.func.isRequired,
    // function to populate Users autocomplete
    fetchUsers: PropTypes.func.isRequired,
    // function to fetch data to generate Report and CSV
    generateReport: PropTypes.func.isRequired,
    // array of challenges to display in autocomplete dropdown
    challenges: PropTypes.array,
    countries: PropTypes.array,
    cities: PropTypes.array,
    // array of tags to display in autocomplete dropdown
    tags: PropTypes.array,
    // array of users to display in autocomplete dropdown
    users: PropTypes.array,
    // array of values to be displayed in table
    preview: PropTypes.array,

    loadingPreview: PropTypes.bool,

    // map pointers to be shown for the current report
    mapData: PropTypes.array,
    report: PropTypes.array,
    user: PropTypes.object,
    permissions: PropTypes.array,
    totalCount: PropTypes.number,
};

DownloadChallenges.defaultProps = {
    challenges: [],
    countries: [],
    tags: [],
    users: [],
    mapData: [],
    preview: [],
    loadingPreview: false,
    permissions: [],
    user: {},
};

const mapStateToProps = (state) => {
    return {
        challenges: getChallenges(state),
        countries: getCountries(state),
        cities: getCities(state),
        tags: getTags(state),
        users: getUsers(state),
        user: getUser(state),
        preview: getPreviewReport(state),
        loadingPreview: getCSVReportLoading(state), // getCSVReportLoading(state),
        // mapData: transformMapData(getCSVReport(state)),
        mapData: [],
        permissions: getUserPermissionsKeys(state),
        report: getCSVReportCOMBO(state),
        totalCount: getTotalCount(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchChallenges: () => dispatch(challengesRequested()),
        fetchCountries: () => dispatch(countriesAndCitiesRequested()),
        setSelectedCountriesIds: (ids) => dispatch(setSelectedCountries(ids)),
        fetchTags: () => dispatch(tagsRequested()),
        fetchUsers: () => dispatch(usersRequested()),
        generateReport: ({
            selectedChallenges,
            selectedUsers,
            selectedTags,
            tagSource,
            selectedStartDate,
            selectedEndDate,
            selectedZipcode,
            selectedRadius,
            selectedCountries,
            selectedCities,
        }) =>
            dispatch(
                generateCSVReportRequested({
                    selectedChallenges,
                    tagSource,
                    selectedUsers,
                    selectedTags,
                    selectedStartDate,
                    selectedEndDate,
                    selectedZipcode,
                    selectedRadius,
                    selectedCountries,
                    selectedCities,
                }),
            ),
    };
};

const ConnectedDownloadChallenges = connect(
    mapStateToProps,
    mapDispatchToProps,
)(DownloadChallenges);

export default ConnectedDownloadChallenges;
